import { IArticleCard } from "data/contentData/interfaces/mongodb/IArticleCard"

export interface IArchiveState {
    articles: IArticleCard[]
    articleCount: number
    templates: string[]
    selectedFilter: string
    skip: number
    shouldFetch: boolean
}

type ACTIONTYPE =
    | { type: "load_more"; payload: number }
    | { type: "update_articlesArray"; payload: IArticleCard[] }
    | {
          type: "new_articlesArray"
          payload: { articleCount: number; articles: IArticleCard[] }
      }
    | {
          type: "update_filter"
          payload: { selectedFilter: string; skip: number }
      }
    | {
          type: "reset_filter"
          payload: {
              articles: IArticleCard[]
              articleCount: number
              template: string
              skip: number
          }
      }

/**
 * this reducer determines what action should be performed on the archive based
 * on the determined action that is passed in.
 * @param state the state in which the Archive is
 * @param action what action should be performed on the archive
 * @returns the archive state which will determine what is rendered and how
 */

export function archiveReducer(state: IArchiveState, action: ACTIONTYPE) {
    switch (action.type) {
        case "load_more":
            return {
                ...state,
                skip: action.payload,
                shouldFetch: true
            }
        case "update_articlesArray":
            return {
                ...state,
                articles: action.payload,
                shouldFetch: false
            }

        case "new_articlesArray":
            return {
                ...state,
                articleCount: action.payload.articleCount,
                articles: action.payload.articles,
                shouldFetch: false
            }

        case "update_filter":
            return {
                ...state,
                selectedFilter: action.payload.selectedFilter,
                skip: action.payload.skip,
                shouldFetch: true
            }

        case "reset_filter":
            return {
                ...state,
                articles: action.payload.articles,
                articleCount: action.payload.articleCount,
                template: action.payload.template,
                selectedFilter: "",
                skip: action.payload.skip,
                shouldFetch: false
            }
        default: {
            const { type } = action
            throw new Error(
                `The action type ${type} is not defined in the archiveReducer`
            )
        }
    }
}
